import { v4 as uuidv4 } from 'uuid';

import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RatingSummary } from '../../../../vtex-apps/peer/reviews-and-ratings/RatingSummary/default';
import { Wishlist } from '../../../../vtex-apps/peer/wishlist/Wishlist/default';
import { ProductPriceSavings } from '../../../../vtex-apps/product-price/ProductPriceSavings/default';
import { ResponsiveLayoutDesktop } from '../../../../vtex-apps/responsive-layout/ResponsiveLayoutDesktop/default';
import { ResponsiveLayoutMobile } from '../../../../vtex-apps/responsive-layout/ResponsiveLayoutMobile/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { ProductImages } from '../../../../vtex-apps/store-components/ProductImages/default';
import { ProductIdentifier } from '../../../../vtex-apps/product-identifier/ProductIdentifier/default';
import { ProductName } from '../../../../vtex-apps/store-components/ProductName/default';
import { ProductHighlights } from '../../../../vtex-apps/product-highlights/ProductHighlights/default';
import { SkuSelector } from '../../../../vtex-apps/store-components/SkuSelector/default';
import { ProductSellingPrice } from '../../../../vtex-apps/product-price/ProductSellingPrice/default';
import { ProductInstallments } from '../../../../vtex-apps/product-price/ProductInstallments/default';
import { ProductQuantity } from '../../../../vtex-apps/product-quantity/ProductQuantity/default';
import { ShippingSimulator } from '../../../../vtex-apps/store-components/ShippingSimulator/default';
import { AddToCartButton } from '../../../../vtex-apps/add-to-cart-button/AddToCartButton/default';
import { Share } from '../../../../vtex-apps/store-components/Share/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { AvailabilityNotify } from '../../../../vtex-apps/AvailabilityNotify/default';
import { ConditionLayoutProduct } from '../../../../vtex-apps/ConditionLayoutProduct/default';
import { ProductBrand } from '../../../../vtex-apps/store-components/ProductBrand/default';
import { ProductSpotPrice } from '../../../../vtex-apps/product-price/ProductSpotPrice/default';
import { ProductGifts } from '../../../../vtex-apps/product-gifts/ProductGifts/default';
import { ProductGiftList } from '../../../../vtex-apps/product-gifts/ProductGiftList/default';
import { GiftText } from '../../../../vtex-apps/product-gifts/GiftText/default';
import { GiftName } from '../../../../vtex-apps/product-gifts/GiftName/default';
import { GiftDescription } from '../../../../vtex-apps/product-gifts/GiftDescription/default';
import { GiftImage } from '../../../../vtex-apps/product-gifts/GiftImage/default';
import { ProductInstallmentsList } from '../../../../vtex-apps/product-price/ProductInstallmentsList/default';
import { ProductInstallmentsListItem } from '../../../../vtex-apps/product-price/ProductInstallmentsListItem/default';
import { SellerTable } from '../../../../vtex-apps/seller-selector/SellerTable/default';
import { SellerSimulateShipping } from '../../../../vtex-apps/seller-selector/SellerSimulateShipping/default';
import { SellerHead } from '../../../../vtex-apps/seller-selector/SellerHead/default';
import { SellerHeadCell } from '../../../../vtex-apps/seller-selector/SellerHeadCell/default';
import { SellerRow } from '../../../../vtex-apps/seller-selector/SellerRow/default';
import { SellerName } from '../../../../vtex-apps/seller-selector/SellerName/default';
import { SellerPrice } from '../../../../vtex-apps/seller-selector/SellerPrice/default';
import { SellerShipping } from '../../../../vtex-apps/seller-selector/SellerShipping/default';
import { SellerPriceWithShipping } from '../../../../vtex-apps/seller-selector/SellerPriceWithShipping/default';
import { SellerAddToCart } from '../../../../vtex-apps/seller-selector/SellerAddToCart/default';
import { SellerBody } from '../../../../vtex-apps/seller-selector/SellerBody/default';
import { ModalHeader } from '../../../../vtex-apps/modal-layout/ModalHeader/default';
import { TabLayout } from '../../../../vtex-apps/tab-layout/TabLayout/default';
import { TabContent } from '../../../../vtex-apps/tab-layout/TabContent/default';
import { TabContentItem } from '../../../../vtex-apps/tab-layout/TabContentItem/default';
import { TabList } from '../../../../vtex-apps/tab-layout/TabList/default';
import { ModalLayout } from '../../../../vtex-apps/modal-layout/ModalLayout/default';
import { ModalTrigger } from '../../../../vtex-apps/modal-layout/ModalTrigger/default';
import { TabListItemChildren } from '../../../../vtex-apps/tab-layout/TabListItemChildren/default';

import { ProductListPrice } from '../../../../vtex-apps/product-price/ProductListPrice/default';
import { ProductSellerName } from '../../../../vtex-apps/product-price/ProductSellerName/default';

export default function ProductImagesDetailsGroup() {
	return {
		componentName: 'SellerTable',
		componentId: uuidv4(),
		componentGroup: 'ProductImagesDetailsGroup',
		props: SellerTable({ mzTitle: 'MZ | Bloco principal' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'product-wrapper__pidg-2',
					marginTop: 9,
					marginBottom: 8,
					preserveLayoutOnMobile: false,
				},
				[
					FlexLayoutCol(
						{
							width: { desktop: '60%', mobile: '100%' },
							blockClass: 'product-image-dg-left__flex-col-pidg-2',
							preventVerticalStretch: true,
						},
						[
							Wishlist({ blockClass: 'product-wishlist__pidg-2' }),
							ProductImages({
								blockClass: 'product-images__pidg-2',
								showPaginationDots: 'always',
								maxHeight: 600,
							}),
							ResponsiveLayoutDesktop({}, [tipBarDesktop]),
						],
					),
					FlexLayoutCol(
						{
							width: { desktop: '40%', mobile: '100%' },
							blockClass: 'product-image-dg-right__flex-col-pidg-2',
						},
						[
							ProductIdentifier(),
							FlexLayoutRow(
								{
									blockClass: 'product-highlights-wrapper__pidg-2',
									preventHorizontalStretch: true,
								},
								[
									ProductHighlights({
										blockClass: 'product-highlights__pidg-2',
									}),
								],
							),
							FlexLayoutRow(
								{
									colSizing: 'auto',
									colGap: { desktop: 3, tablet: 3, phone: 3 },
									marginTop: { desktop: 3, tablet: 3, phone: 3 },
									marginBottom: { desktop: 3, tablet: 3, phone: 3 },
									preserveLayoutOnMobile: true,
									preventHorizontalStretch: true,
								},
								[
									ProductName({ blockClass: 'product-name__pidg-2' }),
									ProductBrand({ blockClass: 'shelf__product-brand-2', height: 40 }),
								],
							),
							RatingSummary({
								blockClass: 'product-reviewsSummary__pidg-2',
							}),
							FlexLayoutRow(
								{
									marginBottom: { desktop: 6, tablet: 6, phone: 6 },
									marginTop: { desktop: 6, tablet: 6, phone: 6 },
								},
								[
									ProductSellerName({
										blockClass: 'product-seller-name__pidg-2',
										markers: ['product-seller-name'],
										message: 'Vendido e entregue por <product-seller-name>{sellerName}</product-seller-name>',
									}),
								],
							),
							ConditionLayoutProduct({
								conditions: [
									{
										subject: 'isProductAvailable',
									},
								],
								Then: FlexLayoutRow({ blockClass: 'available-row__pidg-2' }, [
									FlexLayoutCol({}, [
										FlexLayoutRow(
											{
												blockClass: 'product-price-row__pidg-2',
												colSizing: 'auto',
												colGap: { desktop: 5, tablet: 5, phone: 5 },
												preserveLayoutOnMobile: true,
												preventHorizontalStretch: true,
											},
											[
												FlexLayoutCol(
													{
														blockClass: 'product-price-row__pidg-2__col-1',
													},
													[
														FlexLayoutRow(
															{
																colSizing: 'auto',
																horizontalAlign: 'left',
																marginBottom: { desktop: 3, tablet: 3, phone: 3 },
																blockClass: 'discount-list-price__pidg-2',
															},
															[
																ProductListPrice({
																	blockClass: 'product-list-price__pidg-2',
																}),
																ProductPriceSavings({
																	blockClass: 'product-price-savings__pidg-2',
																	message: 'Economize \n {savingsValue}',
																}),
															],
														),
														ProductSpotPrice({
															message: '{spotPriceValue} à vista no boleto ou depósito.',
															blockClass: 'product-price__spot-price__pidg-2',
														}),
													],
												),
												FlexLayoutCol(
													{
														blockClass: 'product-price-row__pidg-2__col-2',
													},
													[
														FlexLayoutRow(
															{
																colSizing: 'auto',
																preserveLayoutOnMobile: true,
																preventHorizontalStretch: true,
																paddingTop: { desktop: 4, tablet: 4, phone: 4 },
																paddingBottom: { desktop: 4, tablet: 4, phone: 4 },
															},
															[
																FlexLayoutCol(
																	{
																		width: 'auto',
																		verticalAlign: 'center',
																		marginLeft: { desktop: 5, tablet: 5, phone: 5 },
																		marginRight: {
																			desktop: 5,
																			tablet: 5,
																			phone: 5,
																		},
																		blockClass: 'discount-icon__pidg-2',
																	},
																	[
																		Image({
																			blockClass: 'installments-image__pidg-2',
																			src: 'https://hefesto-upload-images.s3.amazonaws.com/1667245254510-card-icon-image-pdp.png',
																		}),
																	],
																),
																FlexLayoutCol(
																	{
																		width: 'auto',
																		marginRight: {
																			desktop: 5,
																			tablet: 5,
																			phone: 5,
																		},
																		preventHorizontalStretch: true,
																	},
																	[
																		ProductSellingPrice({
																			blockClass: 'product-selling-price__pidg-2',
																		}),
																		ProductInstallments({
																			blockClass: 'product-installment__pidg-2',
																		}),
																	],
																),
															],
														),
													],
												),
											],
										),
										ModalTrigger({}, [
											RichText({
												blockClass: 'payment-methods__pidg-2',
												text: '**Ver formas de pagamento**',
											}),
											ModalLayout({ blockClass: 'payment-methods-modal__pidg-2' }, [
												FlexLayoutRow(
													{
														colSizing: 'equal',
														paddingBottom: { desktop: 5, tablet: 5, phone: 5 },
													},
													[
														ModalHeader(
															{
																blockClass: 'payment-modal-header__pidg2',
																iconCloseSize: 20,
															},
															[
																RichText({
																	text: 'Mais Formas de Pagamento',
																	blockClass: 'payment-modal-header__pidg2',
																}),
															],
														),
													],
												),
												FlexLayoutRow({}, [
													TabLayout({}, [
														TabList({ blockClass: 'payment-list-tabs__pidg2' }, [
															TabListItemChildren({ tabId: 'tab-1', label: 'Cartão de crédito' }, [
																Image({
																	src: 'https://hefesto-upload-images.s3.amazonaws.com/1665511442453-pix.png',
																}),
																RichText({
																	blockClass: 'tab-list__pidg2',
																	text: 'Cartão de crédito',
																	textAlignment: 'CENTER',
																	textPosition: 'CENTER',
																}),
															]),
															TabListItemChildren({ tabId: 'tab-2', label: 'Boleto Bancário' }, [
																Image({
																	src: 'https://hefesto-upload-images.s3.amazonaws.com/1665511442453-pix.png',
																}),
																RichText({
																	blockClass: 'tab-list__pidg2',
																	text: 'Boleto Bancário',
																	textAlignment: 'CENTER',
																	textPosition: 'CENTER',
																}),
															]),
															// TabListItemChildren({ tabId: "tab-3", label: "Pix" }, [
															//     Image({ src: "https://hefesto-upload-images.s3.amazonaws.com/1665511442453-pix.png" }),
															//     RichText({ blockClass: "tab-list__pidg2", text: "Pix", textAlignment: "CENTER", textPosition: "CENTER" })
															// ]),
														]),
														TabContent({}, [
															TabContentItem({ blockClass: 'tab-content__pidg2', tabId: 'tab-1' }, [
																ProductInstallmentsList(
																	{
																		paymentSystemName: 'Visa',
																		blockClass: 'installment-list-container__pidg2',
																	},
																	[
																		FlexLayoutRow(
																			{
																				blockClass: 'installment-row__pidg2',
																			},
																			[
																				ProductInstallmentsListItem({
																					blockClass: 'installment-item__pidg2',
																					markers: ['right', 'left', 'center'],
																					message:
																						'<left>{installmentsNumber}x</left> <center>de {installmentValue}</center> {hasInterest, select, false { sem juros}  true {com juros} other {}} <right>total {installmentsTotalValue}</right>',
																				}),
																			],
																		),
																	],
																),
															]),
															TabContentItem(
																{
																	blockClass: 'tab-content__pidg2-nolist',
																	tabId: 'tab-2',
																},
																[
																	ProductSpotPrice({
																		blockClass: 'installment-item__pidg2-nolist',
																		markers: ['right'],
																		message: '{spotPriceValue} no boleto bancário',
																	}),
																	RichText({
																		blockClass: 'tab-info-text__pidg-2',
																		text: ' O boleto será gerado após a finalização de sua compra. Imprima e pague no banco ou pague pela internet utilizando o código de barras do boleto.',
																	}),
																],
															),
															// TabContentItem({ blockClass: "tab-content__pidg2-nolist", tabId: "tab-3" }, [
															//     ProductInstallmentsList({
															//         paymentSystemName: "Pix",
															//         blockClass: "installment-list-container__pidg2"
															//     }, [
															//         FlexLayoutRow({ blockClass: "installment-row__pidg2-nolist" }, [
															//             ProductInstallmentsListItem({
															//                 blockClass: "installment-item__pidg2-nolist",
															//                 markers: ["right"],
															//                 message: "{installmentsTotalValue} no pix"
															//             })
															//         ])
															//     ]),
															//     RichText({ blockClass: "tab-info-text__pidg-2", text: " O pagamento é instantâneo e só pode ser à vista. Na etapa de finalização da compra, a gente explica direitinho como pagar com Pix." })
															// ])
														]),
													]),
												]),
											]),
										]),
										SkuSelector({
											blockClass: 'skuSelector__pidg-2',
											imageHeight: 64,
											imageWidth: 64,
										}),
										FlexLayoutRow({ blockClass: 'add-to-cart-row__pidg-2', colSizing: 'auto' }, [
											ProductQuantity({ blockClass: 'add-to-cart-quantity__pidg-2' }),
											AddToCartButton({
												blockClass: 'add-to-cart-button__pidg-2',
												text: 'Comprar',
												customToastUrl: '/checkout/#/cart',
											}),
										]),
										FlexLayoutRow(
											{
												blockClass: 'product-gift__pidg-2-wrapper',
											},
											[
												ProductGifts({}, [
													FlexLayoutRow(
														{
															blockClass: 'product-gift__pidg-2-header',
															horizontalAlign: 'between',
															colSizing: 'auto',
															preserveLayoutOnMobilet: true,
														},
														[
															RichText({
																text: '**Compre e ganhe**',
																blockClass: 'product-gift__pidg-2-title',
															}),
															GiftText({
																text: '{exceedingItems, plural, =0{ } one {+ # gift} other {+ # gifts}}',
															}),
														],
													),
													ProductGiftList({}, [
														FlexLayoutRow(
															{
																blockClass: 'product-gift__pidg-2-gift-list',
																horizontalAlign: 'between',
																colSizing: 'auto',
																preserveLayoutOnMobile: true,
															},
															[
																FlexLayoutCol(
																	{
																		blockClass: 'product-gift__pidg-2-text-content',
																	},
																	[GiftName(), GiftDescription()],
																),
																GiftImage(),
															],
														),
													]),
												]),
											],
										),
										ConditionLayoutProduct({
											conditions: [
												{
													subject: 'hasMoreSellersThan',
													arguments: {
														value: 1,
													},
												},
											],
											Then: SellerSimulateShipping({ blockClass: 'seller-sim-ship__pidg-2' }),
											Else: ShippingSimulator(),
										}),
									]),
								]),
								Else: FlexLayoutRow(
									{
										blockClass: 'not-available-row__pidg-2',
									},
									[
										FlexLayoutCol({}, [
											//adicionar seletor de sku aqui

											SkuSelector({
												blockClass: 'skuSelector__pidg-2',
												imageHeight: 64,
												imageWidth: 64,
											}),
											AvailabilityNotify(),
										]),
									],
								),
							}),
							Share({
								blockClass: 'share__pidg-2',
								shareLabelClass: 'share-label__pidg-2',
								buttonsContainerClass: 'share-btn-container__pidg-2',
							}),
							ResponsiveLayoutMobile({}, [tipBarMobile]),
						],
					),
				],
			),
			ConditionLayoutProduct({
				conditions: [
					{
						subject: 'hasMoreSellersThan',
						arguments: {
							value: 1,
						},
					},
					{
						subject: 'isProductAvailable',
					},
				],
				Then: FlexLayoutRow(
					{
						blockClass: 'product-image-dg__seller-row-2',
						colGap: 3,
					},
					[
						FlexLayoutCol(
							{
								width: '100%',
								preventVerticalStretch: true,
							},
							[
								RichText({
									blockClass: 'product-sellers-header__pidg2',
									text: 'Ver opções de compra',
									textPosition: 'CENTER',
									textAlignment: 'CENTER',
								}),
							],
						),
						FlexLayoutCol(
							{
								width: '100%',
								preventVerticalStretch: true,
							},
							[
								SellerHead({ blockClass: 'seller__pidg2' }, [
									SellerHeadCell({ title: 'Seller', blockClass: 'seller__pidg2' }),
									SellerHeadCell({ title: 'Price', blockClass: 'seller__pidg2' }),
									SellerHeadCell({ title: 'Shipping', blockClass: 'seller__pidg2' }),
									SellerHeadCell({ title: 'Price With Shipping', blockClass: 'seller__pidg2' }),
									SellerHeadCell({ title: '', blockClass: 'seller__pidg2' }),
								]),
								SellerBody({ blockClass: 'seller__pidg2' }, [
									SellerRow({ blockClass: 'seller__pidg2' }, [
										SellerName({ blockClass: 'seller__pidg2' }),
										SellerPrice({ blockClass: 'seller__pidg2' }),
										SellerShipping({ blockClass: 'seller__pidg2' }),
										SellerPriceWithShipping({ blockClass: 'seller__pidg2' }),
										SellerAddToCart(
											{ blockClass: 'seller__pidg2' },
											[],
											[
												AddToCartButton({
													blockClass: 'add-to-cart-button__pidg-2',
													text: 'Adicionar',
													customToastUrl: '/checkout/#/cart',
												}),
											],
										),
									]),
								]),
							],
						),
					],
				),

				Else: null,
			}),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--text-color-1', to: '--pidg-2-text-color', name: 'General Text' },
			{ from: '--text-color-1', to: '--pidg-2-reviews-color', name: 'Reviews' },
			{ from: '--cta-color-pure', to: '--pidg-2-cta-color', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--pidg-2-cta-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--pidg-2-cta-focus', name: 'CTA Active' },
			{ from: '--white', to: '--pidg-2-cta-text-color', name: 'CTA Text Color' },
			{ from: '--text-color-1-dark', to: '--pidg-2-list-price-color', name: 'List Price' },
			{ from: '--text-color-1', to: '--pidg-2-price-color', name: 'Price' },
			{ from: '--text-color-1', to: '--pidg-2-installments-color', name: 'Installments' },
			{ from: '--cta-color-hover', to: '--pidg-2-discount-bg-color', name: 'Discount Background' },
			{ from: '--white', to: '--pidg-2-discount-text-color', name: 'Discount text' },
			{ from: '--brand-color-primary-pure', to: '--pidg-2-sku-detail-color', name: 'SKU Detail' },
			{ from: '--brand-color-primary-pure', to: '--pidg-2-sku-text-color', name: 'SKU Text' },
			{ from: '--neutral-color-high-light', to: '--pidg-2-sku-hover-bg-color', name: 'SKU Hover' },
			{ from: '--brand-color-primary-pure', to: '--pidg-2-quantity-detail-color', name: 'Select Quantity' },
			{ from: '--text-color-1', to: '--pidg-2-quantity-text-color', name: 'Quantity Text' },
			{ from: '--cta-color-pure', to: '--pidg-2-flag-first-color', name: 'First Highlight Background' },
			{ from: '--brand-color-primary-pure', to: '--pidg-2-flag-color', name: 'Highlight Background' },
			{ from: '--white', to: '--pidg-2-highlight-text-color', name: 'Highlight Text' },
			{ from: '--cta-color-pure', to: '--pidg-2-slider-color', name: 'Slider' },
			{ from: '--neutral-color-high-light', to: '--pidg-2-freight-bg-color', name: 'Freight Background' },
			{ from: '--text-color-1', to: '--pidg-2-freight-header-color', name: 'Freight Header Text' },
			{ from: '--text-color-1', to: '--pidg-2-freight-body-color', name: 'Freight Body Text' },
			{ from: '--text-color-1', to: '--pidg-2-tipbar-text-color', name: 'Tipbar Text' },
			{ from: '--text-color-1', to: '--pidg-2-link-text-color', name: 'Tipbar Link Text' },
			{ from: '--text-color-1', to: '--pidg-2-gift-title-color', name: 'Gift Titles Color' },
			{ from: '--text-color-1-light', to: '--pidg-2-gift-description-color', name: 'Gift Description Color' },
			{ from: '--text-color-1', to: '--pidg-2-gift-qtd-color', name: 'Gift Qtd Color' },
			{ from: '--neutral-color-high-light', to: '--pidg-2-gift-bg-color', name: 'Gift Background Color' },
			{ from: '--white', to: '--pidg-2-gift-item-bg-color', name: 'Gift Item Background Color' },
			{ from: '--support-color-4', to: '--pidg-2-seller-head-bg-color', name: 'Seller Header Bg' },
			{ from: '--text-color-1', to: '--pidg-2-seller-head-text-color', name: 'Seller Header Text' },
			{ from: '--white', to: '--pidg-2-seller-row-bg-color', name: 'Seller Row Bg' },
			{ from: '--text-color-1', to: '--pidg-2-payment-header-color', name: 'Payment Popup Header' },
			{ from: '--text-color-1', to: '--pidg-2-payment-tab-color', name: 'Payment Popup Tab Text' },
			{
				from: '--brand-color-primary-pure',
				to: '--pidg-2-payment-tab-d-color',
				name: 'Payment Popup Tab Detail',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--pidg-2-payment-tab-link-color',
				name: 'Payment Popup link (ver formas de pagamento)',
			},
			{ from: '--support-color-2', to: '--pidg-2-card-price-bg-color', name: 'Card Installments Background' },
			{ from: '--brand-color-primary-pure', to: '--pidg-2-wishlist', name: 'wishlist' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-xs', to: '--pidg-2-br', name: 'Details' },
			{ from: '--border-radius-none', to: '--pidg-2-highlight-br', name: 'Highlight' },
			{ from: '--border-radius-none', to: '--pidg-2-qty-br', name: 'Quantity' },
			{ from: '--border-radius-none', to: '--pidg-2-image-br', name: 'Image' },
			{ from: '--border-radius-sm', to: '--pidg-2-cta-br', name: 'CTA' },
			{ from: '--border-radius-none', to: '--pidg-2-slider-br', name: 'Slider' },
			{ from: '--border-radius-none', to: '--pidg-2-payment-br', name: 'Payment Popup' },
			{ from: '--border-radius-none', to: '--pidg-2-seller-br', name: 'Seller Box' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-nano', to: '--pidg-2-highlight-size', name: 'Highlight' },
			{ from: '--spacing-sm', to: '--pidg-2-sku-height', name: 'Sku Selector Height' },
			{ from: '--spacing-lg', to: '--pidg-2-sku-width', name: 'Sku Selector Width' },
			{ from: '--spacing-sm', to: '--pidg-2-cta-size', name: 'CTA/Qty/Freight' },
			{ from: '--spacing-sm', to: '--pidg-2-dot-width', name: 'Dot Width' },
			{ from: '--spacing-nano', to: '--pidg-2-dot-height', name: 'Dot height' },
			{ from: '--spacing-sm', to: '--pidg-2-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--pidg-2-dot-height-active', name: 'Dot Height Active' },
			{ from: '--spacing-nano', to: '--pidg-2-sku-gap', name: 'Espaçamento SKU' },
			//tipbar lateral spacing
			{ from: '--spacing-xxxs', to: '--pidg-2-tipbar-lateral-spacing', name: 'Tipbar Lateral Spacing' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--pidg-2-text-fs', name: 'General Text' },
			{ from: '--font-size-xxl', to: '--pidg-2-product-name-fs', name: 'Product Name' },
			{ from: '--font-size-xs', to: '--pidg-2-highlight-fs', name: 'Highlight' },
			{ from: '--font-size-sm', to: '--pidg-2-list-price-fs', name: 'List Price' },
			{ from: '--font-size-xxxl', to: '--pidg-2-price-fs', name: 'Price' },
			{ from: '--font-size-xs', to: '--pidg-2-discount-fs', name: 'Discount' },
			{ from: '--font-size-xs', to: '--pidg-2-installments-fs', name: 'Card Installments ' },
			{ from: '--font-size-lg', to: '--pidg-2-installments-total-fs', name: 'Card Installments Total' },
			{ from: '--font-size-xs', to: '--pidg-2-sku-selector-fs', name: 'Sku Selector' },
			{ from: '--font-size-md', to: '--pidg-2-cta-fs', name: 'CTA' },
			{ from: '--font-size-sm', to: '--pidg-2-freight-header-fs', name: 'Freight Head' },
			{ from: '--font-size-xs', to: '--pidg-2-freight-body-fs', name: 'Highlight Body' },
			{ from: '--font-size-xs', to: '--pidg-2-tipbar-fs', name: 'Tipbar' },
			{ from: '--font-size-xs', to: '--pidg-2-link-fs', name: 'Tipbar Link' },
			{ from: '--font-size-md', to: '--pidg-2-gift-title-fs', name: 'Gift Title Size' },
			{ from: '--font-size-sm', to: '--pidg-2-gift-product-title-fs', name: 'Gift Product Title Size' },
			{ from: '--font-size-sm', to: '--pidg-2-gift-gtd-fs', name: 'Gift Qtd Size' },
			{ from: '--font-size-sm', to: '--pidg-2-gift-desc-fs', name: 'Gift Description Size' },
			{ from: '--font-size-xs', to: '--pidg-2-seller-default-fs', name: 'Default Seller' },
			{ from: '--font-size-sm', to: '--pidg-2-seller-h-fs', name: 'Seller Header' },
			{ from: '--font-size-sm', to: '--pidg-2-seller-b-fs', name: 'Seller Body' },
			{ from: '--font-size-sm', to: '--pidg-2-payment-tab-fs', name: 'Payment Popup Tab' },
			{ from: '--font-size-sm', to: '--pidg-2-payment-install-fs', name: 'Payment Popup Installments' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--pidg-2-text-fw', name: 'General Text' },
			{ from: '--font-weight-700', to: '--pidg-2-product-name-fw', name: 'Product Name' },
			{ from: '--font-weight-400', to: '--pidg-2-highlight-fw', name: 'Highlight' },
			{ from: '--font-weight-400', to: '--pidg-2-list-price-fw', name: 'List Price' },
			{ from: '--font-weight-700', to: '--pidg-2-price-fw', name: 'Price' },
			{ from: '--font-weight-400', to: '--pidg-2-discount-fw', name: 'Discount' },
			{ from: '--font-weight-400', to: '--pidg-2-installments-total-fw', name: 'Installments Total' },
			{ from: '--font-weight-400', to: '--pidg-2-installments-fw', name: 'Installments' },
			{ from: '--font-weight-400', to: '--pidg-2-sku-selector-fw', name: 'Sku Selector' },
			{ from: '--font-weight-700', to: '--pidg-2-cta-fw', name: 'CTA' },
			{ from: '--font-weight-700', to: '--pidg-2-freight-header-fw', name: 'Freight Head' },
			{ from: '--font-weight-400', to: '--pidg-2-freight-body-fw', name: 'Highlight Body' },
			{ from: '--font-weight-400', to: '--pidg-2-tipbar-fw', name: 'Tipbar' },
			{ from: '--font-weight-400', to: '--pidg-2-link-fw', name: 'Tipbar Link' },
			{ from: '--font-weight-400', to: '--pidg-2-h-fw', name: 'Seller Header' },
			{ from: '--font-weight-400', to: '--pidg-2-default-seller-fw', name: 'Default Seller' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--pidg-2-text-ff', name: 'General Text' },
			{ from: '--main-font', to: '--pidg-2-product-name-ff', name: 'Product Name' },
			{ from: '--main-font', to: '--pidg-2-highlight-ff', name: 'Highlight' },
			{ from: '--main-font', to: '--pidg-2-list-price-ff', name: 'List Price' },
			{ from: '--main-font', to: '--pidg-2-price-ff', name: 'Price' },
			{ from: '--main-font', to: '--pidg-2-discount-ff', name: 'Discount' },
			{ from: '--main-font', to: '--pidg-2-installments-ff', name: 'Installments' },
			{ from: '--main-font', to: '--pidg-2-sku-selector-ff', name: 'Sku Selector' },
			{ from: '--main-font', to: '--pidg-2-cta-ff', name: 'CTA' },
			{ from: '--main-font', to: '--pidg-2-freight-header-ff', name: 'Freight Head' },
			{ from: '--main-font', to: '--pidg-2-freight-body-ff', name: 'Freight Body' },
			{ from: '--main-font', to: '--pidg-2-tipbar-ff', name: 'Tipbar' },
			{ from: '--main-font', to: '--pidg-2-link-ff', name: 'Tipbar Link' },
			{ from: '--main-font', to: '--pidg-2-seller-h-ff', name: 'Seller Header' },
			{ from: '--main-font', to: '--pidg-2-seller-b-ff', name: 'Seller Body' },
			{ from: '--main-font', to: '--pidg-2-payment-header-ff', name: 'Payment Popup Header' },
			{ from: '--main-font', to: '--pidg-2-payment-tab-ff', name: 'Payment Tab' },
		],
	},
];

const tipBarDesktop = FlexLayoutRow(
	{
		blockClass: 'product-image-tipbar__pidg-2',
		paddingBottom: { desktop: 4, tablet: 4, phone: 4 },
		paddingTop: { desktop: 4, tablet: 4, phone: 4 },
		marginTop: { desktop: 4, tablet: 4, phone: 4 },
	},
	[
		FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-2' }, [
			Image({
				blockClass: 'product-image-tipbar-image__pidg-2',
				src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060441889-cartao-tipbar-icon.png',
				maxHeight: 40,
				maxWidth: 40,
			}),
			RichText({
				blockClass: 'product-image-tipbar-text__pidg-2',
				text: 'Parcele sua compra em até 2 cartões de crédito',
			}),
		]),
		FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-2' }, [
			Image({
				src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
				blockClass: 'product-image-tipbar-image__pidg-2',
				maxHeight: 40,
				maxWidth: 40,
			}),
			RichText({
				blockClass: 'product-image-tipbar-text__pidg-2',
				text: 'Modalidade Compre online e retire na loja para CEPs selecionados',
			}),
		]),
		FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-2' }, [
			Image({
				src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060499860-whatsapp-tipbar-icon.png',
				blockClass: 'product-image-tipbar-image__pidg-2',
				maxHeight: 40,
				maxWidth: 40,
			}),
			RichText({
				blockClass: 'product-image-tipbar-text__pidg-2',
				text: 'Em caso de dúvidas, nossa equipe está te esperando no [WhatsApp](/)',
			}),
		]),
	],
);

const tipBarMobile = FlexLayoutRow(
	{
		colSizing: 'auto',
		blockClass: 'product-image-tipbar__pidg-2-mobile',
		preventHorizontalStretch: true,
		preserveLayoutOnMobile: false,
		paddingBottom: { desktop: 4, tablet: 4, phone: 4 },
		paddingTop: { desktop: 4, tablet: 4, phone: 4 },
		marginTop: { desktop: 4, tablet: 4, phone: 4 },
	},
	[
		FlexLayoutRow(
			{ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-2', preventHorizontalStretch: true },
			[
				Image({
					src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060441889-cartao-tipbar-icon.png',
					blockClass: 'product-image-tipbar-image__pidg-2',
					maxHeight: 40,
					maxWidth: 40,
				}),
				RichText({
					blockClass: 'product-image-tipbar-text__pidg-2',
					text: 'Parcele sua compra em até 2 cartões de crédito',
				}),
			],
		),
		FlexLayoutRow(
			{ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-2', preventHorizontalStretch: true },
			[
				Image({
					src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
					blockClass: 'product-image-tipbar-image__pidg-2',
					maxHeight: 40,
					maxWidth: 40,
				}),
				RichText({
					blockClass: 'product-image-tipbar-text__pidg-2',
					text: 'Modalidade Compre online e retire na loja para CEPs selecionados',
				}),
			],
		),
		FlexLayoutRow(
			{ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-2', preventHorizontalStretch: true },
			[
				Image({
					src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060499860-whatsapp-tipbar-icon.png',
					blockClass: 'product-image-tipbar-image__pidg-2',
					maxHeight: 40,
					maxWidth: 40,
				}),
				RichText({
					blockClass: 'product-image-tipbar-text__pidg-2',
					text: 'Em caso de dúvidas, nossa equipe está te esperando no [WhatsApp](/)',
				}),
			],
		),
	],
);
